import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { BlueprintCollectionOperator, BlueprintCollectionOperators } from '@zinnia/form-engine-sdk';

import { getOptionsFromEnum } from '../../../Helpers/options';
import { QuantifierRadioGroup } from './QuantifierRadioGroup';

type Props = {
  value?: BlueprintCollectionOperator;
  onChange: (value: BlueprintCollectionOperator) => void;
};

export function CollectionAggregateOperatorRadioGroup({ value, onChange }: Props): ReactElement {
  const { t } = useTranslation();

  const options = getOptionsFromEnum<BlueprintCollectionOperator>(
    BlueprintCollectionOperators,
    'admin.conditions.options.collectionOperator',
  ).filter((option) => option.value !== BlueprintCollectionOperators.thisItem);

  return (
    <QuantifierRadioGroup
      label={t('admin.conditions.labels.collectionOperator')}
      name='collection-operator-radio-group'
      options={options}
      value={value}
      onChange={onChange}
    />
  );
}
